/*
 * The eight pages in the header pill, in the order they appear. The footer
 * columns below point at the same routes — a link that exists only in the
 * footer is a link nobody maintains.
 */
export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Academics', to: '/academics' },
  { label: 'Facilities', to: '/facilities' },
  { label: 'News', to: '/news' },
  { label: 'Gallery', to: '/gallery' },
  { label: 'Achievements', to: '/achievements' },
  { label: 'Contact', to: '/contact' },
];

export const footerColumns = [
  {
    heading: 'Academics',
    links: [
      { label: 'Toddler Room', to: '/academics' },
      { label: 'Primary School', to: '/academics' },
      { label: 'Secondary School', to: '/academics' },
      { label: 'Facilities', to: '/facilities' },
    ],
  },
  {
    heading: 'Admissions',
    links: [
      { label: 'How to apply', to: '/#admissions' },
      { label: 'Book a visit', to: '/contact' },
      { label: 'Key dates', to: '/news' },
      { label: 'Catchment area', to: '/contact' },
    ],
  },
  {
    heading: 'The school',
    links: [
      { label: 'About us', to: '/about' },
      { label: 'News & events', to: '/news' },
      { label: 'Gallery', to: '/gallery' },
      { label: 'Achievements', to: '/achievements' },
    ],
  },
];
